import { DEFAULT_LOCATION_ID } from '@enmon/commons/lib/enmon';
import type { IntlShape } from 'react-intl';
import type { TreeSelectProps } from 'antd';
import type { SerializedEstablishmentDropdownView } from '@/services/api/establishments/types/view';
import { Establishments as messages } from '../../messages';

export const transformAndSortEstablishmentsData = (
  nodeData: SerializedEstablishmentDropdownView[] | SerializedEstablishmentDropdownView['buildings'],
  intl: IntlShape,
): TreeSelectProps['treeData'] =>
  nodeData
    .map(branch => ({
      value: branch._id,
      label: `${branch._id === DEFAULT_LOCATION_ID ? intl.formatMessage(messages.default) : branch.name}${
        'buildings' in branch ? ` (${branch.buildings.length})` : ''
      }`,
      children: 'buildings' in branch ? transformAndSortEstablishmentsData(branch.buildings, intl) : [],
    }))
    .sort((branchA, branchB) => branchA.label?.localeCompare(branchB.label));
